import React, { useEffect, useState } from 'react';
import Txt from '../../../inputs/textInput.js';
import { userEmailUpdated } from '../../../../actions/user.js';
import { ValidMe } from '../../../../businessLogic/validation.js';
import { useDispatch } from 'react-redux';
import HtmlToReact from 'html-to-react';
import xss from 'xss';

let htmlToReactParser = new HtmlToReact.Parser(React);

const CenterPanelForgotPassword = (props) => {
  const dispatch = useDispatch();
  const [userEmail, setUserEmail] = useState(props.userEmail);
  const userEmailChanged = (value) => {
    dispatch(userEmailUpdated(value));
  };

  useEffect(() => {
    setUserEmail(props.userEmail);
  }, [props.userEmail]);
  return (
    <div className="ui form ">
      <div data-show={!props.passwordResetRequestCompleted} className="pdtm">
        <ValidMe validmefor="email" group="forgotPasswordForm">
          <Txt
            tabIndex="1"
            focusme="true"
            noTitle
            value={userEmail}
            onChange={userEmailChanged}
            placeholder={APP.LANGUAGE.ForgotPassword.EmailPlaceholder}
          />
        </ValidMe>
        <div className=" ui segment ignored info attached color-info borderless  max-width brdr-radius-null mrbl bg-transparent">
          <p>
            <span className="mrts color-info">
              {APP.LANGUAGE.ForgotPassword.InfoPartOne.replace('##portalName##', window.APP.CONFIGURATION.PORTAL.Name)}
            </span>
            <span className="mrtm color-info">
              {htmlToReactParser.parse(xss(APP.LANGUAGE.ForgotPassword.InfoPartTwo))}
            </span>
          </p>
        </div>
      </div>
      <div data-show={props.passwordResetRequestCompleted == true} className="pdtnull">
        <div className=" ui segment ignored info attached color-info borderless  max-width brdr-radius-null mrbl bg-transparent">
          <p>
            <span className="mrtxs">
              {' '}
              {APP.LANGUAGE.ForgotPassword.ForgotPassWordSuccess} <br /> <b>{userEmail}</b>
            </span>

            <span className="mrts color-info">{APP.LANGUAGE.ForgotPassword.InfoEmailSentSuccessPartOne}</span>
            <span className="mrtm color-info">
              {' '}
              {APP.LANGUAGE.ForgotPassword.InfoEmailSentSuccessPartTwo.replace(
                '##portalName##',
                window.APP.CONFIGURATION.PORTAL.Name
              )}
            </span>
            <span className="mrts color-info">
              {' '}
              {APP.LANGUAGE.ForgotPassword.InfoEmailSentSuccessPartThree.replace(
                '##portalName##',
                window.APP.CONFIGURATION.PORTAL.Name
              )}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CenterPanelForgotPassword;
